import { Entity } from '../../core/Entity';
import { DefineEntity } from '../../core/EntityUtils';
import { Container } from '../display';
import { View2DComponent } from './view/View2DComponent';

export class Entity2D extends DefineEntity(Entity, View2DComponent) {
  public get view(): Container {
    return this.c.view2d.view;
  }

  public get rotation(): number {
    return this.view.rotation;
  }

  public get x(): number {
    return this.view.x;
  }
  public set x(value: number) {
    this.view.x = value;
  }

  public get y(): number {
    return this.view.y;
  }
  public set y(value: number) {
    this.view.y = value;
  }

  public get scaleX(): number {
    return this.view.scaleX;
  }
  public set scaleX(value: number) {
    this.view.scaleX = value;
  }

  public get scaleY(): number {
    return this.view.scaleY;
  }
  public set scaleY(value: number) {
    this.view.scaleY = value;
  }
}
